"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const CheckBoxOutlinedBlank = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" fill="white" />
    <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke="#D6D3CD" />
  </svg>,
  "CheckBoxOutlinedBlank",
)

const CheckBoxOutlinedBlankIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <CheckBoxOutlinedBlank sx={{ fill: _fill, ...sx }} {...rest} />
}

export default CheckBoxOutlinedBlankIcon
